export enum PeriodTypesEnum {
	Year = 'Year',
	Quarter = 'Quarter',
	Month = 'Month',
	Week = 'Week',
	Day = 'Day',
}
